import {SERVICE_LINK} from "@/constant/_Public/Path";

export const serviceLink = SERVICE_LINK;
